module.exports = __webpack_public_path__ + "img/second_bg.e40e8880.webp";